/**
 * Typography scale for VibeChat.
 * Uses Inter as the primary font — clean and modern like Instagram.
 */
const typography = {
  fonts: {
    heading: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
    body:    `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif`,
    mono:    `'JetBrains Mono', 'Fira Code', monospace`,
  },
  fontSizes: {
    xs:   "11px",
    sm:   "13px",
    md:   "15px",
    lg:   "17px",
    xl:   "20px",
    "2xl":"24px",
    "3xl":"30px",
    "4xl":"36px",
  },
  fontWeights: {
    normal:   400,
    medium:   500,
    semibold: 600,
    bold:     700,
  },
};

export default typography;
